import React from 'react';
import cx from 'classnames';
import { CloseIcon, ArrowLeftIcon } from '@move-ui/icons-asset-catalog';
import { GhostInverseButton } from '@move-ui/button';
import styles from './ModalHeader.module.css';
import { SlideDirection } from './SlideDirection';
export const ModalHeader = ({ className, children, showCloseButton = true, iconClassName, onButtonClick = () => null, slideDirection, showBackButton, buttonLabel = showBackButton ? 'go back' : 'close' }) => (React.createElement("div", { className: cx(slideDirection ? styles.slideInModalComponent : styles.component, className) },
    children,
    (showCloseButton || showBackButton) && (React.createElement(GhostInverseButton, { className: cx(slideDirection ? styles.slideInModalButton : styles.button, {
            [styles.buttonLeft]: slideDirection === SlideDirection.ToLeft
        }), onClick: onButtonClick, label: buttonLabel, onKeyDown: (event) => {
            if (event.keyCode === 13 || event.keyCode === 32) {
                onButtonClick();
                event.preventDefault();
            }
        }, iconOnly: true, icon: showBackButton ? (React.createElement(ArrowLeftIcon, { className: cx(styles.buttonIcon, iconClassName), "data-testid": "back-icon" })) : (React.createElement(CloseIcon, { className: cx(styles.buttonIcon, iconClassName), "data-testid": "close-icon" })) }))));
//# sourceMappingURL=ModalHeader.js.map